import { type PropsWithChildren, createContext, useContext } from 'react';

import {
  MeterBarChartDataProviderData,
  MeterBarChartDataProviderProps,
} from '../types/meter-bar-chart-internal.js';

export const MeterBarChartDataContext =
  createContext<MeterBarChartDataProviderData>(
    {} as MeterBarChartDataProviderData,
  );

export const MeterBarChartDataProvider = ({
  children,
  data,
}: PropsWithChildren<MeterBarChartDataProviderProps>) => (
  <MeterBarChartDataContext.Provider value={data}>
    {children}
  </MeterBarChartDataContext.Provider>
);

export const useMeterBarChartData = () => useContext(MeterBarChartDataContext);
